import { createConfigParametersRepository } from '../../../configParametersRepository';
import { gtagWrapper } from '../../google-analytics/utils';
import { DIDOMI_GOOGLE_CONSENT } from './constants';
import { setParams } from './customDimensions';

/**
 * Sets the 'allowAdFeatures' and 'allow_ad_personalization_signals' parameters in Universal Analytics and GA4.
 * Also sets the 'cmp_ad_agreement' custom parameter in the custom dimensions' repository.
 *
 * @param {boolean} adFeaturesAllowed - A boolean indicating whether ad features are allowed.
 */
export const allowAdFeatures = (adFeaturesAllowed: boolean) => {
  gtagWrapper('set', 'allow_ad_personalization_signals', adFeaturesAllowed);

  setParams({
    customParam: 'cmp_ad_agreement',
    value: adFeaturesAllowed.toString(),
  });
};

/**
 * Updates the consent status in Gtag based on the Didomi consent list.
 * If Google consent is included in the Didomi consent list and not in the denied list, all consents are granted.
 * If Google consent is included in the Didomi denied list, all consents except for analytics storage are denied.
 */
export const allowConsent = () => {
  if (!window || !window.didomiState) {
    return;
  }
  if (
    window.didomiState.didomiVendorsConsent?.includes(DIDOMI_GOOGLE_CONSENT) &&
    !window.didomiState.didomiVendorsConsentDenied?.includes(
      DIDOMI_GOOGLE_CONSENT
    )
  ) {
    gtagWrapper('consent', 'update', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted',
    });
  } else if (
    window.didomiState.didomiVendorsConsentDenied?.includes(
      DIDOMI_GOOGLE_CONSENT
    )
  ) {
    gtagWrapper('consent', 'update', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'granted',
    });
  }
};

export const handleConsent = () => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  if (!storageClient) {
    return;
  }
  const { listenChangeUserConsent, isAllowed } = storageClient;
  void listenChangeUserConsent(() => {
    allowAdFeatures(isAllowed('sessionStorage', 'allowAdFeatures'));
    allowConsent();
  });
};
